import React from 'react';
import PropTypes from 'prop-types';
import { ImportantStyles } from './style';

const Element = (props) => {
  const { type, ...rest } = props;

  return <ImportantStyles as={type} {...rest} />;
};

Element.propTypes = {
  type: PropTypes.string.isRequired,
};

export default Element;
